import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { FaArrowLeft } from 'react-icons/fa';

const API = 'https://sendvigo-backend-production.up.railway.app';

export default function AdminChatViewer({ packageId, onBack }) {
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/admin/chats/${packageId}`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        if (d.error) setError(d.error);
        else setData(d);
      })
      .catch(() => setError('Error cargando el chat'));
  }, [packageId, token]);

  return (
    <div style={{minHeight:'100vh', backgroundColor:'#111318'}}>
      <div style={{backgroundColor:'#1a1d24', borderBottom:'1px solid #2a2d35',
        padding:'12px 16px', display:'flex', alignItems:'center', gap:'12px'}}>
        <button onClick={onBack}
          style={{backgroundColor:'#111318', color:'#9ca3af', padding:'8px',
            border:'1px solid #2a2d35', borderRadius:'10px', display:'flex', cursor:'pointer'}}>
          <FaArrowLeft style={{fontSize:'13px'}} />
        </button>
        <div>
          <p className="text-white font-semibold text-sm">Chat del envío (vista admin)</p>
          {data?.package && (
            <p style={{color:'#f97316', fontSize:'11px'}}>{data.package.from} → {data.package.to}</p>
          )}
        </div>
      </div>

      <div style={{maxWidth:'480px', margin:'0 auto', padding:'8px 16px 40px'}}>
        {error && (
          <p style={{color:'#f87171', fontSize:'13px', textAlign:'center', marginTop:'40px'}}>{error}</p>
        )}

        {data?.package && (
          <div style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35', borderRadius:'14px',
            padding:'14px', margin:'16px 0', fontSize:'12px', color:'#9ca3af'}}>
            <p>👤 Remitente: <span style={{color:'white'}}>{data.package.sender?.name}</span> ({data.package.sender?.email})</p>
            {data.package.driver && <p>🚗 Viajero: <span style={{color:'white'}}>{data.package.driver.name}</span> ({data.package.driver.email})</p>}
            <p>📦 Receptor: <span style={{color:'white'}}>{data.package.receiver?.name}</span> ({data.package.receiver?.email})</p>
          </div>
        )}

        {data?.messages?.map(m => {
          if (m.system) {
            return (
              <div key={m.id} style={{textAlign:'center', margin:'12px 0'}}>
                <span style={{backgroundColor:'#22c55e15', color:'#22c55e', fontSize:'11px',
                  padding:'5px 12px', borderRadius:'20px', border:'1px solid #22c55e25'}}>
                  {m.text}
                </span>
              </div>
            );
          }
          return (
            <div key={m.id} style={{marginBottom:'10px'}}>
              <p style={{color:'#f97316', fontSize:'10px', fontWeight:'700', marginBottom:'2px'}}>
                {m.user?.name}
              </p>
              <div style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35', borderRadius:'12px',
                padding:'8px 12px', display:'inline-block', maxWidth:'85%'}}>
                <p style={{color:'white', fontSize:'13px'}}>{m.text}</p>
              </div>
              <p style={{color:'#3a3d45', fontSize:'10px', marginTop:'2px'}}>
                {new Date(m.createdAt).toLocaleString('es-ES')}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}